import { render, staticRenderFns } from "./FormOphthalmicEdit.vue?vue&type=template&id=892706e0&"
import script from "./FormOphthalmicEdit.vue?vue&type=script&lang=js&"
export * from "./FormOphthalmicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports